export default "__VITE_ASSET__Cn7Zd0l2__"